<template>
    <b-container class="chart-holder">
      <b-row v-if="this.cDat">
        <b-col cols="12" class="title" style="text-align:center;"><h3>{{ cDat.title }}</h3></b-col>
        <b-col v-for="chart in cDat.chartDat">
          <LineChart v-if="chart.type == 'line'" :chartdata="chart.chartdata" :options="chart.options"></LineChart>
          <BarChart v-if="chart.type == 'bar'" :chartdata="chart.chartdata" :options="chart.options"></BarChart>
        </b-col>
      </b-row>
    </b-container>
</template>

<script>
  import { ajaxGet, ajaxPost } from "../../../ajax";
  import LineChart from './Infographic3LineChart'
  import BarChart from "./Infographic3BarChart"
  import {apiUrl} from "@/main";
  
  export default{
    components: {
      LineChart,
      BarChart
    },
    data: function(){
      return {
        cDat: undefined,
        infoId: undefined
      }
    },
    created(){
      console.log("CREATED");
      this.infoId = this.$router.history.current.params.infoId;
        var assignmentFlag = (this.$router.history.current.query.Assignment === null) ? 'assignments' : 'content';
            if(this.infoId == 'undefined') alert("Not part of assignment.");
        ajaxGet(apiUrl()+"/"+assignmentFlag+"/" + this.infoId,
        (dat) => {
          //on success dat is called
          if(dat.component == "infographic3"){
            //This is the right component
            // console.log(dat.data);
            this.cDat = dat.data;
            this.isAnswered = dat.answers;
            window.document.title = dat.title;
            //----------------------------------------------------------
            if(this.$router.history.current.query.Assignment === null && !this.isAnswered){
                ajaxPost(apiUrl() +"/assignments/" + this.infoId, {
                Data: {
                    seen: Date.now()
                }
            },
            (suc) => {
                console.log("Posted assignment:", suc);
            },
            (err) => {
                console.log("Error :", err)
            }, localStorage.token);
            }
            //----------------------------------------------------------
          }else{
            //Wrong component type
            console.error("DATA MISMATCH on api call expected 'INFOGRAPHIC3' object, got '" + dat.component.toUpperCase() + "' object.");
          }
        },(err) => {
          //There was some error
          console.log(err);
        }, localStorage.token, this);
    }
  }
</script>

<style>
.chart-holder{
  padding-top: 4em;
  background: #272727;
  color: white;
}
</style>